import { Button } from "@bidbattles/bloks/components/ui/button";
import { DataTable } from "@bidbattles/bloks/components/ui/table";
import { BBBackendQueryOptions, type UserNotification } from "@bidbattles/bloks/lib/rapace";
import { useNotifications } from "@/lib/backend/notifications";
import { paginationSearchParamsSchema } from "@bidbattles/bloks/lib/rapace/utils";
import { ClientOnly, createFileRoute } from "@tanstack/react-router";
import { createColumnHelper } from "@tanstack/react-table";
import { zodValidator } from "@tanstack/zod-adapter";
import { useMemo } from "react";
import { MessageCheckSquare } from "untitledui-js/react";
import z from "zod";

export const Route = createFileRoute("/settings/notifications")({
	validateSearch: zodValidator(
		paginationSearchParamsSchema.extend({
			status: z.enum(["unread"]).optional(),
		}),
	),
	loaderDeps: ({ search }) => search,
	async loader({ context, deps: search }) {
		await context.queryClient.ensureQueryData(
			BBBackendQueryOptions.listNotifications(search),
		);
	},
	component: RouteComponent,
});

const columnHelper = createColumnHelper<UserNotification>();

function RouteComponent() {
	const { status } = Route.useSearch();
	const { notifications, pagination, markAsRead } = useNotifications({
		status,
	});
	const columns = useMemo(
		() => [
			columnHelper.accessor("message", {
				header: "Notification",
				cell: (info) => {
					const [message, created_at] = [
						info.getValue(),
						info.row.original.created_at,
					];
					return (
						<div className="inline-flex flex-col gap-2">
							<span>{message}</span>
							<span className="text-gray-500 text-sm leading-5 h-5">
								<ClientOnly>
									Received at: {created_at.toLocaleString()}
								</ClientOnly>
							</span>
						</div>
					);
				},
			}),
			columnHelper.display({
				id: "actions",
				header: () => <span className="sr-only">Actions</span>,
				cell: (info) => {
					if (info.row.original.read_at) {
						return null;
					}

					return (
						<Button
							variant="icon"
							size="icon"
							className="text-lg"
							onClick={() => markAsRead(info.row.original.id)}
						>
							<MessageCheckSquare stroke="currentColor" size="1em" />
							<span className="sr-only">Mark as read</span>
						</Button>
					);
				},
			}),
		],
		[markAsRead],
	);
	return (
		<>
			<DataTable
				hideFooters
				columns={columns}
				data={notifications}
				pagination={pagination}
			/>
		</>
	);
}
